/* import __COLOCATED_TEMPLATE__ from './loading-skeleton.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
  Args: {};
}

const LoadingSkeleton = templateOnlyComponent<Signature>();
export default LoadingSkeleton;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::LoadingSkeleton': typeof LoadingSkeleton;
    'reporting/automation/ai-insights/optimize/loading-skeleton': typeof LoadingSkeleton;
  }
}
